export default "__VITE_ASSET__DMhYYHev__"